import React, {useEffect, useState} from "react";
import {Tabs} from "components/common";

import {useAppDispatch, useAppSelector} from "redux/hooks";
import type {TabsProps} from "antd";
import Catalog from "./tabs/Catalog/Catalog";
import {tabKeys} from "types/enums";
import Chart from "./tabs/Chart/Chart";
import ListPatientElectrocardiography from "./tabs/ListPatientElectrocardiography/ListPatientElectrocardiography";
import DetailPatientElectrocardiography from "./tabs/DetailDiagnose/DetailElectrocardiography";
import {HistoryExamine} from "components/common";
import {setSiderKey} from "redux/reducer/common";
const Electrocardiography: React.FC = () => {
  document.title = "Điện tim";
  const itemsInit: TabsProps["items"] = [
    {
      key: tabKeys.ELECTROCARDIOGRAPHY.LIST_PATIENT,
      label: `Danh sách bệnh nhân`,
      children: <ListPatientElectrocardiography />,
    },
    {
      key: tabKeys.ELECTROCARDIOGRAPHY.DETAIL_INFO_ELECTRO,
      label: `Chi tiết thông tin`,
      children: <DetailPatientElectrocardiography />,
    },
    {
      key: tabKeys.ELECTROCARDIOGRAPHY.EXAM_HISTORY,
      label: `Lịch sử khám bệnh`,
      children: (
        <HistoryExamine tabName={tabKeys.ELECTROCARDIOGRAPHY.LIST_PATIENT} />
      ),
    },
    // {
    //   key: tabKeys.ELECTROCARDIOGRAPHY.CHART,
    //   label: `Báo cáo nâng cao`,
    //   children: <Chart></Chart>,
    // },
    {
      key: tabKeys.ELECTROCARDIOGRAPHY.CATALOG,
      label: `Cấu hình danh mục điện tim`,
      children: <Catalog></Catalog>,
    },
  ];
  const id = useAppSelector(e => e.electrocardiography.idElectrocardiography);
  const [items, setItems] = useState<TabsProps["items"]>(itemsInit);
  const activeTab = useAppSelector(e => e.common.activeTab);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSiderKey("dienTim"));
  }, []);

  useEffect(() => {
    itemsInit[1].disabled = id == null;
    itemsInit[2].disabled = id == null;
    setItems([...itemsInit]);
  }, [id]);
  return (
    <div className="nurse-out page">
      <div className="main">
        <Tabs items={items} activeKey={activeTab} />
      </div>
    </div>
  );
};
export default Electrocardiography;
